import React from "react";
import { Input } from "../../../common/u1/Input";
import { SelectField } from "../../../common/u1/SelectField";
import { FileUpload } from "../../../common/u1/FileUpload";

/* Step 2 — commercial licence details. Optional since ICC-03: a claim
   completes without a licence, and the details here only pre-fill the Verified
   application made later. Nothing on this step gates Continue. */
export const LicenseStep = ({
  licenseNo = "",
  onLicenseNoChange = () => {},
  state = "",
  onStateChange = () => {},
  stateOptions = [],
  /* The middle level of the cascade: the emirate decides the jurisdictions,
     the jurisdiction narrows the registration bodies. UAE only — elsewhere the
     map has nothing to offer and the field is not drawn. */
  jurisdiction = "",
  onJurisdictionChange = () => {},
  jurisdictionOptions = [],
  registrationBody = "",
  onRegistrationBodyChange = () => {},
  registrationBodyOptions = [],
  /* The UAE has a known list of authorities; elsewhere the registering body is whatever the licence names, so it is typed. */
  bodyAsText = false,
  file = null,
  onFileChange = () => {},
  errors = {},
}) => (
  <div className="grid gap-3.5">
    <div className="grid gap-3.5 sm:grid-cols-2">
      <Input
        id="claim-license-no"
        label="Commercial License No."
        labelVariant="caption"
        value={licenseNo}
        onChange={(e) => onLicenseNoChange(e.target.value)}
        placeholder="e.g. 67890"
        error={errors.licenseNo}
      />
      <SelectField
        id="claim-license-state"
        label="State / Emirate"
        value={state}
        onChange={(e) => onStateChange(e.target.value)}
        options={stateOptions}
        placeholder={stateOptions.length ? "Select a state" : "No states available"}
        error={errors.state}
      />
    </div>

    {/* Jurisdiction sits between the emirate and the authority: a Dubai Mainland licence and a Dubai Free Zone licence are issued by different bodies, so asking... */}
    {jurisdictionOptions.length > 0 && (
      <SelectField
        id="claim-license-jurisdiction"
        label="Jurisdiction"
        value={jurisdiction}
        onChange={(e) => onJurisdictionChange(e.target.value)}
        options={jurisdictionOptions}
        placeholder="Select a jurisdiction"
        error={errors.jurisdiction}
      />
    )}

    {/* The authority map covers the UAE only, so there is a known list to pick from there. */}
    {!bodyAsText ? (
      <SelectField
        id="claim-registration-body"
        label="Registration Body"
        value={registrationBody}
        onChange={(e) => onRegistrationBodyChange(e.target.value)}
        options={registrationBodyOptions}
        disabled={registrationBodyOptions.length === 0}
        placeholder={
          registrationBodyOptions.length
            ? "Select a registration body"
            : "Choose a jurisdiction first"
        }
        error={errors.registrationBody}
      />
    ) : (
      <Input
        id="claim-registration-body"
        label="Registration Body"
        labelVariant="caption"
        value={registrationBody}
        onChange={(e) => onRegistrationBodyChange(e.target.value)}
        placeholder="e.g. Ministry of Corporate Affairs"
        hint="As named on your registration certificate."
        error={errors.registrationBody}
      />
    )}

    <FileUpload
      id="claim-trade-license"
      label="Trade License"
      recommended
      value={file}
      onChange={onFileChange}
      hint="PDF, JPG, or PNG. Required later when you apply for Verified."
    />
  </div>
);

export default LicenseStep;
